const load = require('./load-assets');
const util = require('./util');

let stream = {
    iOS : false,
    library : false,
    list : false,
    init : ( selector ) => {
        selector = selector || '[data-background-video]';
        //if the selector is not set or not a string
        if( !typeof selector === 'string' || selector instanceof String ) return;
        //selector is a string, grab it
        stream.list = document.querySelectorAll(selector);
        if ( !stream.list.length > 0 ) return;
        //check for iOS device
        stream.iOS = util.iOS();
        //Add all elements to intersection observe
        stream.onScreen();
        //Load HLS library if not on iOS (where .m3u8 is native)
        stream.iOS || stream.library ? stream.create()  :  load.asset('https://unpkg.com/hls.js/dist/hls.min.js', 'script', ()=> {
            stream.create();
        }, true);
        //if the user navigates away, paused the video
        window.onblur = () => {
            stream.idle();
        }
    },
    create : () => {
        stream.list.forEach(el => {
            const src = el.getAttribute('data-background-video');
            if( src ) {
                 if ( !stream.iOS ) {
                      let hls = new Hls();
                      hls.loadSource(src);
                      hls.attachMedia(el)
                    //   hls.on(Hls.Events.MEDIA_ATTACHED);
                 } else {
                      const source = document.createElement('source');
                      source.setAttribute('src', src);
                      source.setAttribute('type', 'application/x-mpegURL');
                      el.appendChild(source);
                 }
            }
        })
    },
    onScreen : () => {
        const list = stream.list;
        const observer = new IntersectionObserver( list => {
            list.forEach( video => {
                video.isIntersecting ? video.target.play() : video.target.pause();
            } )
        }, { 
            threshold : .1,
            rootMargin : "-70px 0px"
        } ) 
        list.forEach( item => {
            observer.observe( item );
        } )
    },
    idle : () => {
        console.log('user navigated away pausing video');
        stream.list.forEach( item => {
            item.pause();
        } )
    }
}

module.exports = stream;